import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { Button } from 'app/components/ui/Button'
import { Modal } from 'app/components/ui/Modal'
import { useDeleteSponsorRequest } from 'app/queries/sponsorRequests'
import React from 'react'
import { useQueryClient } from 'react-query'
import styled from 'styled-components'

type Props = {
  sponsorRequestId: number
  onCancel: () => void
  onConfirm: () => void
}
export const SponsorRequestDeleteModal = ({
  sponsorRequestId,
  onCancel,
  onConfirm,
}: WithChildren<Props>): JSX.Element => {
  const queryClient = useQueryClient() // Create a query client instance

  const {
    mutate: deleteSponsorRequest,
    isLoading,
    error,
  } = useDeleteSponsorRequest()

  const deleteSponsorRequestHandler = () =>
    deleteSponsorRequest(
      {
        sponsor_request_id: sponsorRequestId.toString(),
      },
      {
        onSuccess: () => {
          onConfirm()
          queryClient.invalidateQueries('getSponsorRequest') // Invalidate and refetch
        },
      }
    )

  return (
    <Modal
      onCloseRequest={() => onCancel()}
      hasOuterScroll
      title={`Conferma l'operazione`}
    >
      <ModalWrapper>
        Sei sicuro di voler procedere con l&apos;eliminazione della richiesta?
      </ModalWrapper>
      <ButtonApiErrorWrapper isError={!!error} error={error}>
        <ButtonsWrapper>
          <Button onClick={onCancel} variant='grey'>
            Annulla
          </Button>
          <Button
            onClick={() => {
              deleteSponsorRequestHandler()
            }}
            disabled={isLoading}
          >
            {isLoading ? 'Caricamento...' : 'Conferma'}
          </Button>
        </ButtonsWrapper>
      </ButtonApiErrorWrapper>
    </Modal>
  )
}

const ModalWrapper = styled.div`
  margin: 1rem 0 3rem 0;
`

const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  button:first-child {
    margin: 0 0 1rem 0;
  }

  @media (min-width: ${({ theme }) => theme.bp.tablet}) {
    flex-direction: row;
    justify-content: flex-end;

    button:first-child {
      margin: 0 1rem 0 0;
    }
  }
`
